import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoFacilityOrderUSIntakeClinicalInformationModalTemplate } from 'themes/application/niko-facility-order-us-intake/components';
import { NikoFacilityOrderUSIntakeClinicalInformationModalStore } from 'application/niko-facility-order-us-intake/stores';

@setCurrentView((rootStore, componentProps) => new NikoFacilityOrderUSIntakeClinicalInformationModalStore(rootStore, componentProps), 'nikoFacilityOrderUSIntakeClinicalInformationModalStore')
@observer
class NikoFacilityOrderUSIntakeClinicalInformationModal extends React.Component {
    render() {
        return <NikoFacilityOrderUSIntakeClinicalInformationModalTemplate {...this.props} />
    }
}

export default NikoFacilityOrderUSIntakeClinicalInformationModal;
